export const persianToEnglish = (str: string | number): string => {
  const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
  const arabicNumbers = "٠١٢٣٤٥٦٧٨٩";
  const englishNumbers = "0123456789";

  let result = str.toString();

  for (let i = 0; i < 10; i++) {
    result = result.replace(
      new RegExp(persianNumbers[i], "g"),
      englishNumbers[i]
    );
    result = result.replace(
      new RegExp(arabicNumbers[i], "g"),
      englishNumbers[i]
    );
  }

  return result;
};
